/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { OrganisationSettings } from "./OrganisationSettings";
import {
  OrganisationSettingsFromJSON,
  OrganisationSettingsFromJSONTyped,
  OrganisationSettingsToJSON,
  OrganisationSettingsToJSONTyped,
} from "./OrganisationSettings";

/**
 *
 * @export
 * @interface CreateOrganisation
 */
export interface CreateOrganisation {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  uniqueId?: string;
  /**
   *
   */
  name: string;
  /**
   *
   */
  settings?: OrganisationSettings;
}

/**
 * Check if a given object implements the CreateOrganisation interface.
 */
export function instanceOfCreateOrganisation(value: object): value is CreateOrganisation {
  if (!("name" in value) || value["name"] === undefined) return false;
  return true;
}

export function CreateOrganisationFromJSON(json: any): CreateOrganisation {
  return CreateOrganisationFromJSONTyped(json, false);
}

export function CreateOrganisationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CreateOrganisation {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    uniqueId: json["unique_id"] == null ? undefined : json["unique_id"],
    name: json["name"],
    settings: json["settings"] == null ? undefined : OrganisationSettingsFromJSON(json["settings"]),
  };
}

export function CreateOrganisationToJSON(json: any): CreateOrganisation {
  return CreateOrganisationToJSONTyped(json, false);
}

export function CreateOrganisationToJSONTyped(
  value?: Omit<CreateOrganisation, "url"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    unique_id: value["uniqueId"],
    name: value["name"],
    settings: OrganisationSettingsToJSON(value["settings"]),
  };
}
